import { downloadData, getUrl, list } from "aws-amplify/storage";
import { fetchCurrentSession } from "../../util/login";
import { selectIsLoggedIn } from "../authorization/slices";

export const downloadDataQueryFn = async ({ path }, redux) => {
  if (!path) {
    return { error: "Path is required" };
  }
  try {
    const isLoggedIn = selectIsLoggedIn(redux.getState());
    if (!isLoggedIn) {
      try {
        await fetchCurrentSession();
      } catch (authError) {
        return { error: "Authentication required to access storage" };
      }
    }
    const { body, contentType } = await downloadData({ path }).result;
    const text = await body.text();
    if (contentType === "application/json") {
      const parsedFile = JSON.parse(text);
      return {
        data: parsedFile,
      };
    }
    return { data: text };
  } catch (error) {
    return { error: error.message };
  }
};

export const getUrlQueryFn = async ({ path }, redux) => {
  if (!path) {
    return { error: "Path is required" };
  }
  try {
  const listResult = await list({ path, pageSize: 1 });
  const fileExists = (listResult?.items || []).some(
    (item) => item?.path === path
  );
  if (!fileExists) {
    return { error: "File does not exist" };
  }
  const { url: fileUrl } = await getUrl({ path });
    if (fileUrl) {
      return {
        data: {
          href: fileUrl.href
        },
      };
    } else {
      return { error: "File not found" };
    }
  } catch (error) {
    return { error: error.message };
  }
};
